import ContentCard from './ContentCard';
import ContentCardHorizontal from './ContentCardHorizontal';
import ContentCardSkeleton from './ContentCardSkeleton';

export default Object.assign(ContentCard, {
    Horizontal: ContentCardHorizontal,
    Skeleton: ContentCardSkeleton
});
